module.exports = __webpack_public_path__ + "static/media/Homepage - Tablet 728x90.e76bb878.png";